__turbopack_context__.v({
  "switchBox": "RvH7bG_switchBox",
  "switchBoxMen": "RvH7bG_switchBoxMen",
  "switchLink": "RvH7bG_switchLink",
  "switchWrap": "RvH7bG_switchWrap",
});
